import { makeStyles, Theme } from '@material-ui/core'

const buildStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'absolute',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    minHeight: '80px',
    zIndex: 100,
  },
  item: {
    padding: '10px',
  },
  closeIcon: {
    marginLeft: 'auto',
    cursor: 'pointer',
  },
}))

export default buildStyles
